import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, MapPin } from 'lucide-react';
import { MagneticButton } from '@/components/MagneticButton';

// Prominent LIVE — Ongoing Projects section. Shared by Home and Projects so both
// stay consistent. Subtle green pulse respects reduced-motion (motion-safe:).
export const LiveProjects = ({ projects = [], showAll = true }) => {
  const live = projects.filter((p) => p.ongoing);
  if (!live.length) return null;
  return (
    <section className='relative bg-[#101517]' data-testid='live-projects-section'>
      <div className='grain absolute inset-0' />
      <div className='relative container-x py-20 lg:py-28'>
        <div className='flex flex-col justify-between gap-6 md:flex-row md:items-end'>
          <div>
            <span
              className='inline-flex items-center gap-2 rounded-full border border-[#17a34a]/40 bg-[#17a34a]/10 px-3 py-1'
              data-testid='live-badge'
            >
              <span className='relative flex h-2.5 w-2.5'>
                <span className='absolute inline-flex h-full w-full rounded-full bg-[#22c55e] opacity-70 motion-safe:animate-ping' />
                <span className='relative inline-flex h-2.5 w-2.5 rounded-full bg-[#22c55e]' />
              </span>
              <span className='text-[11px] font-semibold uppercase tracking-[0.18em] text-[#4ade80]'>Live — Ongoing Projects</span>
            </span>
            <h2 className='mt-5 font-head text-3xl font-semibold text-[#F6F5F1] sm:text-4xl'>Currently on the ground.</h2>
          </div>
          {showAll && (
            <MagneticButton to='/projects' variant='secondary' className='shrink-0 text-[#F6F5F1]' data-cursor='VIEW'>
              All Projects
            </MagneticButton>
          )}
        </div>

        <div className='mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3'>
          {live.map((p) => (
            <Link
              key={p.slug}
              to='/projects'
              data-cursor='VIEW'
              data-testid={`live-project-${p.slug}`}
              className='group relative overflow-hidden rounded-2xl border border-white/10 p-7 transition-colors duration-300 hover:border-[#B88A3B]/40'
              style={{ background: 'linear-gradient(145deg, #1b2427 0%, #0f1719 100%)' }}
            >
              <div className='flex items-center justify-between'>
                <span className='inline-flex items-center gap-1.5 rounded-full bg-[#22c55e]/12 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-[#4ade80]'>
                  <span className='h-1.5 w-1.5 rounded-full bg-[#22c55e] motion-safe:animate-pulse' /> Live
                </span>
                <ArrowUpRight size={20} className='text-[#B88A3B] transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5' />
              </div>
              <h3 className='mt-6 font-head text-2xl font-semibold text-[#F6F5F1]'>{p.associatedBrand || p.projectTitle}</h3>
              {p.client && <p className='mt-2 text-sm text-[#F6F5F1]/55'>{p.client}</p>}
              {p.location && (
                <p className='mt-3 inline-flex items-center gap-1.5 text-sm text-[#F6F5F1]/55'>
                  <MapPin size={14} className='text-[#B88A3B]' /> {p.location}
                </p>
              )}
              <span className='mt-6 block h-px w-0 bg-[#B88A3B] transition-all duration-500 group-hover:w-16' />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
